// extracted by mini-css-extract-plugin
export default {"desc":"BaseInfo_desc__jRtGy","background":"BaseInfo_background__7HgGi","setIot":"BaseInfo_setIot__lg1pt","optionsBtn":"BaseInfo_optionsBtn__d7K-e"};